// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 500px) {
    .scl--web-page-company-our-value-section{
        max-height: 1401px;
    }

    .scl--web-page-company-hero-section .scl--conic-com-spotlight{
        width: 45%;
    }

    .scl--web-page-company-hero-section .scl--web-component-hero-content button{
        width: 205px;
        height: 45px;
        border-radius: 30px;
    }

    .scl--wpcovs-se-con-str .scl--stv-con-bo-str{
        padding-left: var(--global-mobile-padding-left);
        padding-right: var(--global-mobile-padding-right);
        gap: 50px;
    }

    .scl--wpcovs-se-con-str .scl-scbs-mai-ti-con-str span{
        font-size: var(--font-size-body-ssm);
    }

    .scl--wpcovs-se-con-str .scl--scbs-sec-ti-con-bo-str .scl--sstcbs-ti-str{
        font-size: 70px;
    }

    .scl--wpcovs-se-con-str .scl--scbs-sec-ti-con-bo-str  .sc--sstcbs-pa-str{
        font-size: 24px;
    }

    .scl--stv-con-bo-str .scl--scbs-sec-ti-con-bo-str .sc--sstcbs-pa-str{
        width: 100%;
        line-height: 30px;
        font-size: 24px;
    }

    .scl--step-comp-box-cont-stl .scl--web-component-talent-description{
        font-size: 24px;
    }

    .scl--web-page-company-hero-section .scl--web-component-hero-content{
        padding-left: var(--global-mobile-padding-left);
    }

    .scl--wpctas-dc-art-con-str .scl--web-component-contact-card-description{
        font-size: 24px;
    }

    .scl--web-page-company-hero-section .scl--wpchs-con-st .scl--web-component-hero-title{
        line-height: normal;
    }

    .scl--web-page-company-hero-section .scl--wpchs-con-st .scl--web-component-hero-title span{
        font-size: 50px;
        font-weight: lighter;
    }

    .scl--wdacs-bo-car-con-st{
        min-height: 360px;
        padding-bottom: 60px;
    }

    .scl--wdacs-bo-car-con-st .scl--dcbs-con-met-st-str{
        width: 100%;
    }

    .scl--wpcops-con-sec-str .scl--web-component-section-description-container{
        width: 100%;
        padding-top: 40px;
    }

    .scl--step-comp-box-cont-stl .scl--web-component-talent-title {
        font-size: 30px;
    }

    .scl--wpcops-dc-art-con-str{
        margin-top: 85px;
    }

    .scl--wpcops-bo-cont-str-compl  .scl--wpcops-dc-art-con-str .scl--dca-con-bo-str, .scl--wpcops-dc-art-con-str .scl--wdacs-bo-car-con-st .scl--dca-con-bo-str {
        border: none;
        padding: 0;
    }

    .scl--wpcops-dc-art-con-str .scl--wdacs-bo-car-con-st .scl--dcbs-st-con-str{
        gap: 80px;
    }

    .scl--wdacs-bo-car-con-st .scl--dcbs-con-met-st-str h6{
        font-size: 30px;
    }

    .scl--wpcs-cont-stl-bo{
        padding-left: var(--global-mobile-padding-left);
        padding-right: var(--global-mobile-padding-right);
    }

    .scl--wpctas-st-cont-bo-st{
        grid-template-columns: repeat(1, minmax(100px, 1fr));
    }

    .scl--wpcops-con-sec-str .scl--web-component-section-title-text-container{
        padding-top: 70px;
    }
    
    .scl--step-comp-box-cont-stl .scl--web-component-talent-content .scl--web-component-talent-button{
        width: 100%;
        height: 55px;
        border-radius: 30px;
    }

    .scl--step-comp-box-cont-stl .scl--web-component-talent-content .scl--web-component-talent-button .scl--web-component-talent-button-text{
        font-size: 28px;
        line-height: normal;
    }

    .scl--step-comp-box-cont-stl .scl--web-component-talent-content .scl--web-component-talent-button svg{
        width: 25px;
        height: 25px;
        margin-top: 5px;
    }

    .scl--wpctas-dc-art-con-str .scl--wpctas-bo-car-con-st .scl--web-component-contact-card-inner .scl--web-component-contact-styled-button{
        width: 100%;
        border-radius: 30px;
        height: 56px;
        background: rgba(40, 40, 40, 1);
    }

    .scl--wpctas-dc-art-con-str .scl--wpctas-bo-car-con-st:last-child .scl--web-component-contact-card-inner .scl--web-component-contact-styled-button:last-child{
        background-color: transparent;
    }

    .scl--wpctas-dc-art-con-str .scl--wpctas-bo-car-con-st .scl--web-component-contact-card-inner .scl--web-component-contact-styled-button .scl--web-component-round-button-text{
        width: auto;
        font-size: 24px;
    }

    .scl--wpctas-dc-art-con-str{
        margin-top: 70px;
    }

    .scl--wpchs-tal-con-str .scl--scbs-sec-ti-con-bo-str{
        gap: 60px;
    }

    .scl--wpchs-tal-con-str .scl--scbs-sec-ti-con-bo-str .scl--sstcbs-ti-str{
        line-height: 67px;
    }

    .scl--wtcs-nea-fo-lin-dcl-st{
        gap: 35px;
    }

    .scl--mai-com-bx-cont-st .scl--web-component-section-description-text{
        line-height: 30px;
        font-size: 24px;
    }

    .scl--wpcops-dc-art-con-str .scl--wdacs-bo-car-con-st .scl--dcbs-st-con-str .scl--dcbs-con-met-st-str p{
        line-height: 30px;
        font-size: 24px;
    }
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/company/css/companySm.css"],"names":[],"mappings":"AAAA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;QACjD,SAAS;IACb;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,+CAA+C;IACnD;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,oDAAoD;IACxD;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,YAAY;QACZ,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ","sourcesContent":["@media (max-width: 500px) {\n    .scl--web-page-company-our-value-section{\n        max-height: 1401px;\n    }\n\n    .scl--web-page-company-hero-section .scl--conic-com-spotlight{\n        width: 45%;\n    }\n\n    .scl--web-page-company-hero-section .scl--web-component-hero-content button{\n        width: 205px;\n        height: 45px;\n        border-radius: 30px;\n    }\n\n    .scl--wpcovs-se-con-str .scl--stv-con-bo-str{\n        padding-left: var(--global-mobile-padding-left);\n        padding-right: var(--global-mobile-padding-right);\n        gap: 50px;\n    }\n\n    .scl--wpcovs-se-con-str .scl-scbs-mai-ti-con-str span{\n        font-size: var(--font-size-body-ssm);\n    }\n\n    .scl--wpcovs-se-con-str .scl--scbs-sec-ti-con-bo-str .scl--sstcbs-ti-str{\n        font-size: 70px;\n    }\n\n    .scl--wpcovs-se-con-str .scl--scbs-sec-ti-con-bo-str  .sc--sstcbs-pa-str{\n        font-size: 24px;\n    }\n\n    .scl--stv-con-bo-str .scl--scbs-sec-ti-con-bo-str .sc--sstcbs-pa-str{\n        width: 100%;\n        line-height: 30px;\n        font-size: 24px;\n    }\n\n    .scl--step-comp-box-cont-stl .scl--web-component-talent-description{\n        font-size: 24px;\n    }\n\n    .scl--web-page-company-hero-section .scl--web-component-hero-content{\n        padding-left: var(--global-mobile-padding-left);\n    }\n\n    .scl--wpctas-dc-art-con-str .scl--web-component-contact-card-description{\n        font-size: 24px;\n    }\n\n    .scl--web-page-company-hero-section .scl--wpchs-con-st .scl--web-component-hero-title{\n        line-height: normal;\n    }\n\n    .scl--web-page-company-hero-section .scl--wpchs-con-st .scl--web-component-hero-title span{\n        font-size: 50px;\n        font-weight: lighter;\n    }\n\n    .scl--wdacs-bo-car-con-st{\n        min-height: 360px;\n        padding-bottom: 60px;\n    }\n\n    .scl--wdacs-bo-car-con-st .scl--dcbs-con-met-st-str{\n        width: 100%;\n    }\n\n    .scl--wpcops-con-sec-str .scl--web-component-section-description-container{\n        width: 100%;\n        padding-top: 40px;\n    }\n\n    .scl--step-comp-box-cont-stl .scl--web-component-talent-title {\n        font-size: 30px;\n    }\n\n    .scl--wpcops-dc-art-con-str{\n        margin-top: 85px;\n    }\n\n    .scl--wpcops-bo-cont-str-compl  .scl--wpcops-dc-art-con-str .scl--dca-con-bo-str, .scl--wpcops-dc-art-con-str .scl--wdacs-bo-car-con-st .scl--dca-con-bo-str {\n        border: none;\n        padding: 0;\n    }\n\n    .scl--wpcops-dc-art-con-str .scl--wdacs-bo-car-con-st .scl--dcbs-st-con-str{\n        gap: 80px;\n    }\n\n    .scl--wdacs-bo-car-con-st .scl--dcbs-con-met-st-str h6{\n        font-size: 30px;\n    }\n\n    .scl--wpcs-cont-stl-bo{\n        padding-left: var(--global-mobile-padding-left);\n        padding-right: var(--global-mobile-padding-right);\n    }\n\n    .scl--wpctas-st-cont-bo-st{\n        grid-template-columns: repeat(1, minmax(100px, 1fr));\n    }\n\n    .scl--wpcops-con-sec-str .scl--web-component-section-title-text-container{\n        padding-top: 70px;\n    }\n    \n    .scl--step-comp-box-cont-stl .scl--web-component-talent-content .scl--web-component-talent-button{\n        width: 100%;\n        height: 55px;\n        border-radius: 30px;\n    }\n\n    .scl--step-comp-box-cont-stl .scl--web-component-talent-content .scl--web-component-talent-button .scl--web-component-talent-button-text{\n        font-size: 28px;\n        line-height: normal;\n    }\n\n    .scl--step-comp-box-cont-stl .scl--web-component-talent-content .scl--web-component-talent-button svg{\n        width: 25px;\n        height: 25px;\n        margin-top: 5px;\n    }\n\n    .scl--wpctas-dc-art-con-str .scl--wpctas-bo-car-con-st .scl--web-component-contact-card-inner .scl--web-component-contact-styled-button{\n        width: 100%;\n        border-radius: 30px;\n        height: 56px;\n        background: rgba(40, 40, 40, 1);\n    }\n\n    .scl--wpctas-dc-art-con-str .scl--wpctas-bo-car-con-st:last-child .scl--web-component-contact-card-inner .scl--web-component-contact-styled-button:last-child{\n        background-color: transparent;\n    }\n\n    .scl--wpctas-dc-art-con-str .scl--wpctas-bo-car-con-st .scl--web-component-contact-card-inner .scl--web-component-contact-styled-button .scl--web-component-round-button-text{\n        width: auto;\n        font-size: 24px;\n    }\n\n    .scl--wpctas-dc-art-con-str{\n        margin-top: 70px;\n    }\n\n    .scl--wpchs-tal-con-str .scl--scbs-sec-ti-con-bo-str{\n        gap: 60px;\n    }\n\n    .scl--wpchs-tal-con-str .scl--scbs-sec-ti-con-bo-str .scl--sstcbs-ti-str{\n        line-height: 67px;\n    }\n\n    .scl--wtcs-nea-fo-lin-dcl-st{\n        gap: 35px;\n    }\n\n    .scl--mai-com-bx-cont-st .scl--web-component-section-description-text{\n        line-height: 30px;\n        font-size: 24px;\n    }\n\n    .scl--wpcops-dc-art-con-str .scl--wdacs-bo-car-con-st .scl--dcbs-st-con-str .scl--dcbs-con-met-st-str p{\n        line-height: 30px;\n        font-size: 24px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
